import { createRouter, createWebHistory } from 'vue-router'
import Home from '../components/MainComponent.vue'
import Login from '../components/Login.vue'

//Все роуты во фронте

const routes = [{
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/users-list',
        name: 'UsersList',
        component: () =>
            import ('../components/UsersList.vue'),
        meta: {
            role: 'Администратор',
        }
    },
    {
        path: '/showcase-list',
        name: 'ShowCaseList',
        component: () =>
            import ('../components/ShowCaseList.vue'),
        meta: {
            role: 'Администратор',
        }
    },
    {
        path: '/product-list',
        name: 'ProductList',
        component: () =>
            import ('../components/ProductList.vue'),
        meta: {
            role: 'Администратор',
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
})

//Проверка роли перед переходом во фронте 

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));
    if (!token || !user) {
        if (to.name == 'Login') {
            next();
        } else {
            next({
                name: 'Login'
            });
        }
    } else {
        if (to.meta.role) {
            if (user.role.name == to.meta.role) {
                if (to.name == 'Login') {
                    next({
                        name: 'Home'
                    });
                } else {
                    next();
                }
            } else {
                next({
                    name: 'Home'
                });
            }
        } else {
            if (to.name == 'Login') {
                next({
                    name: 'Home'
                });
            } else {
                next();
            }
        }
    }
})

export default router